<template>
  <refresh-list @onLoad="onLoad" :list="list" @onRefresh="init" ref="refreshList" noDataMessage="这里空空如也，快去创建第一个活动吧">
    <div>
      <div class="card-item" v-for="(item, index) in list" :key="index">
        <div class="top-box">
          <div class="left-box">
            <van-image class="image" radius="6px" :src="item.backgroundImg" fit="cover" />
            <div class="badge-text">活动id：{{item.activityId}}</div>
            <div class="tag">{{item.activityTag|tagFormat}}</div>
          </div>
          <div class="right-box">
            <div class="title-box">{{item.activityTitle}}</div>
            <div class="row">
              <span class="key">开始时间：</span>
              <span class="value">{{item.startTime|dateFormat}}</span>
            </div>
            <div class="row">
              <span class="key">结束时间：</span>
              <span class="value">{{item.endTime|dateFormat}}</span>
            </div>
             <div class="row">
              <span class="key">报名费：</span>
              <span class="value orange" v-if="+item.signUpfee > 0">¥{{item.signUpfee}}</span>
              <span class="value orange" v-else>免费</span>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <!-- 不是草稿箱 -->
          <template v-if="+active != activityStatusEnum.draft">
            <!-- 自己创建并且状态不是已结束 -->
            <div class="item" v-if="(item.activityTag == activityTagEnum.myCreated) && active != activityStatusEnum.ended" @click="close(item)">关闭</div>
            <!-- 非活动老师或数钱特殊角色-->
            <div class="item" v-if="userInfo.countAuthority || !isTeacher"  @click="handleActivity(item, 'poster')">海报分享</div>
            <div class="item" @click="handleActivity(item, 'manager')">管理</div>
          </template>
          <template v-else>
            <div class="item" @click="deleteActivity(item.activityId)">删除</div>
            <div class="item" @click="handleActivity(item, 'edit')">编辑</div>
          </template>
          
        </div>
      </div>
    </div>
    <div slot="no-data">
      <van-button 
        v-if="isTeacher || isDistributor || isShopowner"
        type="default" 
        plain 
        @click="$router.push('/template')" 
        style="margin-top: 15px;">
        立即创建
      </van-button>
    </div>
  </refresh-list>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import loadingMixin from '@/mixins/loading-mixin'
import {activityTagEnum, activityStatusEnum} from '@/utils/constant'

import noDataImg from '@/assets/images/img-default@2x.png'
import timeIcon from '@/assets/icons/card_icon_time@2x.png'
import refreshList from '@/components/refresh-list/refresh-list'
export default {
  name: 'DataLook',
  mixins: [loadingMixin],
  components: {
    refreshList,
  },
  props: {
    active: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      activityTagEnum, 
      activityStatusEnum,
      noDataImg: noDataImg,
      timeIcon: timeIcon,
      pageNum: 1,
      pageSize: 20,
      list: [],
    }
  },
  computed: {
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide',
      'userInfo'
    ])
  },
   mounted() {
    this.init();
  },
  methods: {
    onLoad() {
      this.getActivityData();
    },
    onRefresh() {
      setTimeout(_=>{
        this.init();
      },800)
    },
    handleChange() {
      this.$nextTick(()=>{
        this.init();
      })

    },
    async init() {
      this.pageNum = 1;
      this.list = [];
      this.$refs['refreshList'].reset();
      this.showLoading();
      await this.getActivityData().catch(console.log);
      this.hideLoading();
    },
    getActivityData() {
      let data = {
        filterData: {
          activityName: '',
          dataType: this.active
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      return this.$api.h5.home(data)
        .then(({data}) => {
          let list = data.list;
          if (list) {
            this.list.push(...list);
            this.pageNum = data.pageNum + 1;
            this.$refs['refreshList'].complete(data);
          } else {
            this.$refs['refreshList'].onFinish();
          }
        });
    },
    close(item) {
      this.$funcDialog.show({
        content: '请问是否关闭当前活动？<br />关闭后将不可恢复！'
      });
      this.$funcDialog.addEventListener(status=>{
        if(status == 'cancel') return;
        this.$api.h5.closeActivity(item.activityId)
        .then(res=>{
          this.init();
        })
      });
    },
    deleteActivity(id) {
      this.$funcDialog.show({
        content: '请问是否删除当前草稿？<br />删除后不可恢复！'
      });
      this.$funcDialog.addEventListener(status=>{
        if(status == 'cancel') return;
        this.$api.h5.deleteActivity(id)
        .then(res=>{
          this.init();
        })
      });
    },
    to(item, p) {
      this.$router.push({
        path: p,
        query: {
          ...item,
          active: this.active
        }
      })
    },
    // pathType: 1 查看  2 编辑
    handleActivity(item, pathType) {
      const pathMap = {
        view: '/activity-home',
        editBasic: '/activity/edit-basic',
        edit: '/activity/edit',
        manager: '/activety-manager',
        poster: '/activity/promotion-poster'
      }
      const query = {
        activityId: item.activityId,
        from: 'home'
      };
      if (pathType == 'edit' && item.createWay == 'new') {
        pathMap.edit = '/newActivity/create',
        query.creationMode = 'new',
        query.tmpType = item.tmpType || '1'
      }

      if (['editBasic', 'manager'].includes(pathType)) {
        query.activeTab = this.active;
      }
      if (item.status == 3 && pathType == 'poster') {
        this.$toast('当前活动已经结束，无法操作');
      }else {
        this.$router.push({
          path: pathMap[pathType],
          query
        })
      }
    }
  },
  filters: {
    formatActive(val) {
      if(val == 1) {
        return '待开始'
      }else if(val == 2) {
        return '进行中'
      }else if(val == 3) {
        return '已结束'
      }else if(val == 0) {
        return '草稿箱'
      }
    },
    dateFormat(val, patern="YYYY-MM-DD HH:mm:ss") {
      return moment(val).format(patern)
    },
    tagFormat(val) {
      if(val == 1) {
        return '我创建'
      }else if(val == 2) {
        return '经销商'
      }else if(val == 3) {
        return '活动老师'
      }else if(val == 4) {
        return '活动管理员'
      }
    }
  }
  
}
</script>

<style lang="stylus" scoped>
.card-item {
  background: #FFFFFF;
  border-radius: 8px;
  margin-bottom: 10px;
  .top-box {
    display flex;
    padding: 10px;
    .left-box {
      position: relative;
      width: 100px;
      height: 100px;
      .image {
        width: 100%;
        height: 100%;
      }
      .tag {
        position: absolute;
        left: 0;
        top: 0;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #fff;
        padding: 0 6px;
        border-radius: 10px 0px 10px 0px;
        border: 1px solid #FF734B;
        background: #FF6B31;
      }
      .badge-text {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 18px;
        line-height 18px
        background: rgba(0,0,0,0.3);
        border-radius: 0px 0px 6px 6px;
        color: #fff;
        font-size: 10px;
        text-align: center;
        padding: 0 6px;
        box-sizing border-box;
      }
    }
    .right-box {
      flex: 1;
      margin-left: 10px;
      margin-top: 2px;
      .title-box {
        color: #333333;
        font-size: 15px;
        font-weight: bold;
        margin: 0px 0 16px 0;
      }
      .row {
        display flex;
        font-size: 14px; 
        margin-top: 6px;
        .key {
          color: #999999;
        }
        .value {
          color: #666666;
        }
        .orange {
          color: #FF6B31;
        }
      }
    }
  }
  .bottom-box {
    display: flex;
    align-items: center;
    margin-top: 17px;
    height: 34px;
    background: #FFF7F4;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    .item {
      flex: 1;
      text-align center
      line-height: 13px;
      color: #FF6B31;
      font-size: 14px;
      border-right: 1px solid #999999;
      &:last-child {
        border-right: none;
      }
    }
  }
}

.no-data
  text-align center
  color #BBBBBB
  font-size 14px
  line-height 2
  padding-top 80px
  height calc(100vh - 50px - 245px - 50px - 100px)


</style>


